import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class MediumDigitalIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16"><defs><path id="a" d="M15 0a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H9v2h4.5a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1H7v-2H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm0 1H1v9h14V1zm-1.832 3c.459 0 .832.378.832.842v3.316a.838.838 0 0 1-.832.842H9.832A.837.837 0 0 1 9 8.158V4.842C9 4.378 9.373 4 9.832 4zM7.5 8a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zm5.671-3.145H9.83v3.29h3.342v-3.29zM7.501 6A.5.5 0 0 1 7.5 7h-5a.5.5 0 0 1 0-1zm0-2A.5.5 0 0 1 7.5 5h-5a.5.5 0 0 1 0-1zM13.5 2a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1z"/></defs><g fill="none" fillRule="evenodd"><mask id="b" fill="#fff"><use xlinkHref="#a"/></mask><use fill="#000" xlinkHref="#a"/><g fill="#8D979A" mask="url(#b)"><path d="M0 0h16v16H0z"/></g></g></svg>
        )
    }
}

export default withCssClassName(MediumDigitalIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/medium-digital-icon.js